let testURL = process.env.VUE_APP_HOST_API + "api/auth/";
import { api } from "../core/api";

export default {
  Login(data) {
    return api.post(testURL + "sign-in", data);
  },
};
